import { X } from 'lucide-react';

import { Dialog, DialogClose, DialogContent, DialogTitle } from '@/shared/components/ui/Dialog';

interface HelpGuideModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function HelpGuideModal({ open, onOpenChange }: HelpGuideModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[95vh] w-[95vw] max-w-none translate-x-[-50%] translate-y-[-50%] flex-col gap-0 overflow-hidden p-0">
        <div className="border-border flex shrink-0 items-center justify-between border-b px-5 py-3">
          <DialogTitle>ChartAI User Guide</DialogTitle>
          <DialogClose
            className="text-muted-foreground hover:bg-muted hover:text-foreground flex h-8 w-8 items-center justify-center rounded-md transition-colors"
            aria-label="Close user guide"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </DialogClose>
        </div>
        <iframe
          src="/user-guide.html"
          title="ChartAI User Guide"
          className="h-full w-full flex-1 border-0"
        />
      </DialogContent>
    </Dialog>
  );
}
